import { type Locale } from './locale.types'

export const LOCALE_COOKIE_KEY = 'locale'
export const LOCALE_PARAM_KEY = 'locale'

export const ES_ES = 'es-ES'
export const EN_US = 'en-US'
export const PT_BR = 'pt-BR'
export const FR_FR = 'fr-FR'

export const LOCALES = ['en-US', 'es-ES', 'pt-BR', 'fr-FR'] as const
export const DEFAULT_LOCALE: Locale = EN_US

export const localeFlagCode = {
  [ES_ES]: 'es',
  [EN_US]: 'us',
  [PT_BR]: 'br',
  [FR_FR]: 'fr',
}

export const localeLable = {
  [ES_ES]: 'Español',
  [EN_US]: 'English',
  [PT_BR]: 'Português',
  [FR_FR]: 'Français',
}
